(ns common.number-format
  (:require [clojure.string :as string]))

(def thousand-separators #{"", " " "," "." "'"})
(def decimal-separators #{"," "."})

(def thousand-separators-options
  (->> thousand-separators
       (mapv (fn [s]
               {:value s
                :label s}))
       (sort-by :value)))

(def decimal-separators-options
  (->> decimal-separators
       (mapv (fn [s]
               {:value s
                :label s}))
       (sort-by :value)))

(defn decimal-separator-from-text
  [number-format]
  (let [res (-> number-format
                (string/split #"0")
                (second))]
    ;(js/console.log "Decimal : " number-format " > " res)
    res))

(defn thousand-separator-from-text
  [number-format]
  (let [res (-> number-format
                (string/split #"#")
                (second))]
    ;(js/console.log "Thousand : " number-format " > " res)
    res))

(defn separators-as-strings
  [number-format]
  (let [res (cond (keyword? number-format)
                  (case number-format
                    :number-format/space-comma [" " ","]
                    :number-format/space-period [" " "."]
                    :number-format/comma-period ["," "."]
                    :number-format/period-comma ["." ","]
                    ["," "."])
                  (string? number-format)
                  [(thousand-separator-from-text number-format)
                   (decimal-separator-from-text number-format)])]
    ;(js/console.log "Separators : " number-format " > " res)
    res))

(defn decimal-separator
  [number-format]
  (-> (separators-as-strings number-format)
      (second)))

(defn thousand-separator
  [number-format]
  (-> (separators-as-strings number-format)
      (first)))

(defn char-re-pattern
  [char]
  (case char
    "." #"\."
    "," #","
    "'" #"'"
    " " #"\s"
    (re-pattern (str char))))

(def non-numeric-pattern #"[^\d\.-]")

(defn find-non-numeric-chars [input]
  (re-find non-numeric-pattern input))
